import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AdminSteps from '../common/AdminSteps';
import {Row, Col, Table} from 'react-bootstrap';
import * as groupActions from '../../actions/groupActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import Spinner from 'react-spinkit';
import CustomPagination from '../common/CustomPagination';
import { browserHistory } from 'react-router';
import config from '../../config';


class GroupsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      groupsLoaded: false,
      groups: [],
      startGroups: 0,
      endGroups: config.tableRowsNum,
      activeGroupsPage: 1,
      name: {
        up: false,
        down: false,
        idle: true
      },
      description: {
        up: false,
        down: false,
        idle: true
      },
      memberships: {
        up: false,
        down: false,
        idle: true
      },
      budget_adjustment: {
        up: false,
        down: false,
        idle: true
      }
    };

    this.handleGroupSearch = this.handleGroupSearch.bind(this);
    this.searchGroups = this.searchGroups.bind(this);
    this.setGroupsToState = this.setGroupsToState.bind(this);
    this.pageBack = this.pageBack.bind(this);
    this.pageForward = this.pageForward.bind(this);

    this.reorder = this.reorder.bind(this);
    this.sortByKeyAndDirection = this.sortByKeyAndDirection.bind(this);
    this.checkKey = this.checkKey.bind(this);


  }
  componentWillMount() {
    if(!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if(this.props.groups.length < 1) {
      this.props.groupActions.getAllGroups()
        .then(() => {
          this.setState({groupsLoaded: true});
        });
    } else {
      this.setState({groupsLoaded: true});
    }
    this.setGroupsToState(this.props.groups);
    document.onkeydown = this.checkKey;

  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.groups != this.props.groups) {
      this.setGroupsToState(nextProps.groups);
      this.setState({groupsLoaded: true});
    }
  }


  checkKey(e) {
    if(this.refs.groups) {
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        if(this.state.activeGroupsPage > 1) {
          this.pageBack();
        }
      }
      else if (e.keyCode == '39') {
        // right arrow
        if(this.state.activeGroupsPage < Math.ceil(this.state.groups.length / config.tableRowsNum)) {
          this.pageForward();
        }
      }
    }
  }

  handleGroupSearch(e) {
    e.preventDefault();
    let term = e.target.value;
    if(term != '') {
      let arrUnique = this.searchGroups(term,this.props.groups);
      this.setState({
        groups:arrUnique,
        startGroups: 0,
        endGroups: config.tableRowsNum,
        activeGroupsPage: 1
      });
    } else {
      this.setGroupsToState(this.props.groups);
    }
  }

  searchGroups(term, groups) {
    let b = groups.filter(group => {
      return group.name.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        group.description.toLowerCase().indexOf(term.toLowerCase()) != -1;
    });
    return b;
  }

  setGroupsToState(groups) {
    this.setState({groups: groups});
  }

  pageBack() {
    let newActivePage = this.state.activeGroupsPage -1;
    this.setState({activeGroupsPage: newActivePage});
    if(newActivePage == 1) {
      this.setState({startGroups: 0, endGroups: config.tableRowsNum});
    } else {
      let start = newActivePage * config.tableRowsNum - config.tableRowsNum ;
      let end = newActivePage * config.tableRowsNum;
      this.setState({startGroups: start, endGroups:end});
    }
  }
  pageForward() {
    let newActivePage = this.state.activeGroupsPage +1;
    this.setState({activeGroupsPage: newActivePage});
    let start = newActivePage * config.tableRowsNum - config.tableRowsNum ;
    let end = newActivePage * config.tableRowsNum;
    this.setState({startGroups: start, endGroups:end});
  }

  // Ordering
  reorder(column) {
    if(this.state[column].idle) {
      this.setState({[column]:{
        up: true,
        down: false,
        idle: false
      }});
      let a = this.sortByKeyAndDirection(this.state.groups, column, 'up');
      this.setState({groups: a});
    } else if (this.state[column].up) {
      this.setState({[column]:{
        up: false,
        down: true,
        idle: false
      }});
      let a = this.sortByKeyAndDirection(this.state.groups, column, 'down');
      this.setState({groups: a});
    } else if (this.state[column].down) {
      this.setState({[column]:{
        up: true,
        down: false,
        idle: false
      }});
      let a = this.sortByKeyAndDirection(this.state.groups, column, 'up');
      this.setState({groups: a});
    }
    let obj = {
      name: {
        up: false,
        down: false,
        idle: true
      },
      description: {
        up: false,
        down: false,
        idle: true
      },
      memberships: {
        up: false,
        down: false,
        idle: true
      },
      budget_adjustment: {
        up: false,
        down: false,
        idle: true
      }
    };

    delete obj[column];
    this.setState(obj);

    // Reset pagination
    this.setState({
      startGroups: 0,
      endGroups: config.tableRowsNum,
      activeGroupsPage: 1
    });
  }

  sortByKeyAndDirection(array, key, direction) {
    if(key != 'membership') {
      return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        if(direction == 'up') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        } else if(direction == 'down') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
      });
    } else if (key == 'membership') {
      return array.sort(function(a, b) {
        var x = a.memberships.length; var y = b.memberships.length;
        if(direction == 'up') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        } else if(direction == 'down') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
      });
    }
  }


  handleEditGroup(group) {
    browserHistory.push('/administer/'+localStorage.getItem('run')+'/group/'+group.id);
  }
  addGroup() {
    browserHistory.push('/administer/'+localStorage.getItem('run')+'/group/');
  }


  render() {
    const { run } = this.props;
    const { assignment_complete } = run;

    return (
      <Col md={12}>
        <div className="page-title">Manage Groups</div>
        <AdminSteps active="3" label={this.props.run.slug}/>
        <Row>
          <Col md={10}>
            <div className="form-group search">
              <span className="fa fa-search"></span>
              <input
                name="groupsSearchInput"
                onChange={(e)=>{this.handleGroupSearch(e)}}
                type="text"
                className="form-control"
                placeholder="Type name or description..."/>
              <span className="input-description">Type name or description to filter groups</span>
            </div>
          </Col>
          <Col md={2}>
            <button
              type="button"
              className="btn btn-block btn-ter"
              onClick={()=> {this.addGroup()}}
            >Add Group</button>
          </Col>
        </Row>

        <Row ref="groups" className="height480">
          {this.state.groupsLoaded ?
          <Col  md={12}>
            {this.props.groups.length > 0 ?
              <div className="c-table classes-table">
                <Table condensed hover>
                  <thead>
                  <tr>
                    <th className="name" onClick={()=>{this.reorder('name')}}><span>Name {this.state.name.up ? <i className="fa fa-sort-up"></i> : null}{this.state.name.down ? <i className="fa fa-sort-down"></i> : null} {this.state.name.idle ?<i className="fa fa-sort"></i> : null }</span></th>
                    <th onClick={()=>{this.reorder('memberships')}}><span>Students {this.state.memberships.up ? <i className="fa fa-sort-up"></i> : null}{this.state.memberships.down ? <i className="fa fa-sort-down"></i> : null} {this.state.memberships.idle ?<i className="fa fa-sort"></i>: null }</span></th>
                    { !assignment_complete && <th onClick={()=>{this.reorder('budget_adjustment')}}><span>Budget adjustment {this.state.budget_adjustment.up ? <i className="fa fa-sort-up"></i> : null}{this.state.budget_adjustment.down ? <i className="fa fa-sort-down"></i> : null} {this.state.budget_adjustment.idle ?<i className="fa fa-sort"></i>: null }</span></th> }
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.state.groups.slice(this.state.startGroups, this.state.endGroups).map((group,index) => {
                    return <tr key={index}>
                      <td className="class-name"><span onClick={()=>{this.handleEditGroup(group)}}>{group.name}</span></td>
                      <td className="class-desc">{group.memberships.length}</td>
                      { !assignment_complete && <td className="class-desc">{'+'+group.budget_adjustment/100}</td> }
                      <td className="class-edit"><span onClick={()=>{this.handleEditGroup(group)}}>Edit</span></td>
                    </tr>
                  })}
                  </tbody>
                </Table>
                <CustomPagination
                  activePage={this.state.activeGroupsPage}
                  onBack={this.pageBack}
                  onForward={this.pageForward}
                  listLength={Math.ceil(this.state.groups.length / config.tableRowsNum)}/>
              </div>
              :
              <div className="text-center">No Groups</div>}
          </Col>
            : <div className="spinner-box">
            <Spinner spinnerName="three-bounce" className="mt-4"/>
          </div> }
        </Row>
      </Col>
    );
  }
}


function mapStateToProps(state) {
  return {
    run: state.run,
    groups:state.groups
  };
}

function mapDispatchToProps(dispatch) {
  return {
    groupActions: bindActionCreators(groupActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupsPage);



// WEBPACK FOOTER //
// ./src/components/groups/GroupsPage.js